<template>
  <section>
    <div style='margin:50px auto;width:600px;height: 357px;font-size:22px;line-height:100px;'>温馨提示：正在跳转为开心互联支付网关，请您稍等...
    </div>
    <!--   <div v-html="payHtml"></div> -->
  </section>
</template>
<script>
import { payOrder } from 'api/order';
export default {
  data() {
    return {
      orderId: this.$route.query.orderId,
      orderNo: this.$route.query.orderNo
      //  payHtml:''
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.payOrder();
    })
  },
  methods: {
    // 立即付款
    payOrder() {
      // payOrder({orderId: this.orderId}).then(resp => {
      //   if (resp.resCode === 1) {

      //     this.payHtml = resp.data;
      //     setTimeout(()=>{
      //       document.pay_form.submit();
      //     },1000)
      //   } else {
      //     alert(resp.resDesc)
      //     window.close()
      //   }
      // }).catch(err => {
      //   console.log('err', err)
      // })

      this.$router.push({
        path: '/toPay',
        query: {
          orderId: this.orderId,
          orderNo: this.orderNo,
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// pay.vue?2f5dae32